/**
 * Types and interfaces for Team Information Shares Line Chart visualization
 */

/**
 * Interface for a single data point in the chart
 */
export interface TeamPerformanceData {
  period: number // The x-axis point (1, 2, 3, ...)
  team1Shares: number // Y-value for Team 1
  team2Shares?: number // Y-value for Team 2 (optional - only present when multiple teams exist)
}

/**
 * Props for the main line chart component
 */
export interface TeamInformationSharesLineChartProps {
  data: TeamPerformanceData[]
  height?: number
  width?: string
}

/**
 * Props for the custom tooltip component
 */
export interface TeamInformationSharesLineChartTooltipProps {
  active?: boolean
  payload?: Array<{
    name: string
    value: number
    color: string
    dataKey: string
  }>
  label?: string | number
}

/**
 * Props for the custom legend component
 */
export interface TeamInformationSharesLineChartLegendProps {
  payload?: Array<{
    value: string
    color: string
    type?: string
  }>
}

/**
 * Props for the container component
 */
export interface TeamInformationSharesLineChartContainerProps {
  data?: TeamPerformanceData[]
  title?: string
}

/**
 * Team identifier enum
 */
export enum TeamIdentifier {
  TEAM_1 = 'Team 1',
  TEAM_2 = 'Team 2'
}
